import { signal } from '@angular/core';
import { FieldTree, SchemaPathTree, debounce, max, min, required } from '@angular/forms/signals';
import { PFDto } from '../../../../core/mceapi.client.generated';

export interface PowerFactor {
  pf: number,
  lagging: boolean,
}

export function buildPowerFactorSchema(path: SchemaPathTree<PowerFactor>) {

  required(path.pf, { message: `Power Factor is required` });
  min(path.pf, 0, { message: `Power Factor must be positive` });
  max(path.pf, 1, { message: `Power Factor must be less than or equal to 1` });
  debounce(path.pf, 500);
}

export function createPowerFactor(dto: PFDto) {
  if (dto.pf === undefined || dto.lagging === undefined) {
    throw new Error('Power factor DTO is missing required values.');
  }

  return signal<PowerFactor>({
    pf: dto.pf,
    lagging: dto.lagging,
  });
}

export function createPowerFactorDto(pf: FieldTree<PowerFactor>) {
  return signal<PFDto>({
    pf: pf.pf().value(),
    lagging: pf.lagging().value(),
  })
}
